export const undefiny = <T>(value?: T) => {
  return value;
};

export type NoInfer<T> = [T][T extends any ? 0 : any];
export type LowInfer<T> = T & NonNullable<unknown>;

export const buildEmptyArray = <T extends any[]>(...values: T) => {
  return values;
};

export const anify = <T>(value: unknown) => {
  return value as T;
};

export const arrayify = <T>(values?: T | T[]): T[] => {
  if (!values) return [];
  return Array.isArray(values) ? values : [values];
};
